import { Inject } from 'inversify-props'
import type { MarketplaceServiceAdapter } from './adapter'

export class IntegracaoMarketplaceUseCase {
	@Inject('MarketplaceServiceAdapter')
	private marketplaceAdapter!: MarketplaceServiceAdapter

	integrarProdutos = async (lojaId: string): Promise<void> =>
		this.marketplaceAdapter.integrarProdutos(lojaId)
}